import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobileInterstitial = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 21,
			height: 43,
			rx: 1.5,
			fill: "white",
			stroke: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 4,
			width: 21,
			height: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 9,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 13,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 25,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 37,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 17,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 29,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 21,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 33,
			width: 14,
			height: 2,
			rx: 1,
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24,
			width: 20,
			height: 44,
			rx: 1,
			fill: "var(--format-icon-color, #A8F0F0)"
		})
	]
});
export default SvgMobileInterstitial;
